module.exports = __webpack_public_path__ + "static/media/1001160MF.e784d45d.jpg";